import { makeStyles } from '@material-ui/core/styles'
import {
  CARD_BORDER,
  CARD_SHADOW,
  MUTED_TEXT,
} from '../../register/registration-with-payment-intents/redesign/styles'

// Page chrome (page, inner, backLink, grid, summary*, factRow, ...) is shared
// with the registration redesign; these are the pieces only the host messages
// page needs.
const useStyles = makeStyles(theme => ({
  chatCard: {
    display: 'flex',
    flexDirection: 'column',
    height: 'min(760px, calc(100vh - 270px))',
    minHeight: 520,
    overflow: 'hidden',
    backgroundColor: theme.palette.common.white,
    borderRadius: 24,
    border: `1px solid ${CARD_BORDER}`,
    boxShadow: CARD_SHADOW,
    [theme.breakpoints.down('sm')]: {
      height: 'min(640px, calc(100vh - 140px))',
      minHeight: 460,
    },
    [theme.breakpoints.down('xs')]: {
      borderRadius: 20,
    },
  },
  chatHeader: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${CARD_BORDER}`,
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 2),
    },
  },
  host: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  hostAvatar: {
    width: 48,
    height: 48,
    flexShrink: 0,
    border: `2px solid ${theme.palette.secondary.light}`,
    backgroundColor: theme.palette.grey.light,
    color: theme.palette.common.white,
    fontSize: 18,
  },
  hostName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: 20,
    lineHeight: 1.25,
  },
  hostRole: {
    display: 'block',
    color: MUTED_TEXT,
    fontSize: 13,
    lineHeight: 1.4,
  },
  profileLink: {
    flexShrink: 0,
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 700,
    textDecoration: 'underline',
    '&:hover': {
      color: theme.palette.primary.main,
      textDecoration: 'underline',
    },
  },
  chatBody: {
    position: 'relative',
    flex: 1,
    minHeight: 0,
  },
  chatBodyInner: {
    position: 'absolute',
    inset: 0,
  },
  registerWrap: {
    marginTop: theme.spacing(3),
  },
}))

export default useStyles
